import { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Layout from "./components/Layout";
import DigitalAgencyPage from "./components/Pages/DigitalAgencyPage";
import Checkout from "./components/Pages/Shop/Checkout";
import ErrorPage from "./components/Pages/ErrorPage";
import SignUpPage from "./components/Pages/SignUpPage";
import SignInPage from "./components/Pages/SignInPage";
import ProfilePage from "./components/Pages/ProfilePage";
import ForgotPasswordPage from "./components/Pages/ForgotPasswordPage";
import PaymentSuccess from "./components/Pages/PaymentSuccess";
import PrivacyPolicyPage from "./components/Pages/PrivacyPolicyPage";
import TermsConditionsPage from "./components/Pages/TermsConditionsPage";
import ShippingPolicyPage from "./components/Pages/ShippingPolicyPage";
import CancellationRefundPage from "./components/Pages/CancellationRefundPage";
import ContactPage from "./components/Pages/ContactPage";
import ScrollToHash from "./components/Layout/ScrollToHash";
import SubmitReviewPage from "./components/Pages/SubmitReviewPage";

function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <ScrollToHash />
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<DigitalAgencyPage/>}/>
        <Route path="signup" element={<SignUpPage />} />
        <Route path="signin" element={<SignInPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="checkout" element={<Checkout />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="payment-success" element={<PaymentSuccess />} />
        <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="terms-conditions" element={<TermsConditionsPage />} />
        <Route path="shipping-policy" element={<ShippingPolicyPage />} />
        <Route path="cancellation-refund" element={<CancellationRefundPage />} />
        <Route path="submit-review" element={<SubmitReviewPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Route>
    </Routes>
    </>
  );
}

export default App;
